import FontFaceObserver from 'fontfaceobserver';
export var fontsLoaded = () => {
        var OpenSans = new FontFaceObserver('Open Sans');
        var $html = $('html');
    OpenSans.load().then(function() {
        $html.addClass('os-font-loaded');
      }, function () {
      if(console && console.log) console.info('OpenSans is not available');
    });
};
